import { PutProducts } from "../api/index";
import { GetProductById } from "../api/viewgres_v4";
import { ShowApiError } from "@/request/error";
import form from "../mixins/form";
export default {
  mixins: [form],
  methods: {
    updateByVgcId(row) {
      if (row.vgc_product_id == null) {
        this.$message.error("请先绑定唯格云产品");
        return;
      }

      this.$msgbox({
        title: "提示",
        message: `是否确定将[${row.name.cn}]与唯格云产品同步?`,
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            try {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "开始同步...";
              const { data } = await GetProductById(row.vgc_product_id);
              instance.confirmButtonText = "正在构建表单...";
              let formData = this.buildFormByVgcData(data);
              formData.seq = row.seq;
              instance.confirmButtonText = "正在覆盖数据...";
              await PutProducts([
                {
                  id: row.id,
                  ...formData
                }
              ]);
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "同步完成";
              this.$message.success("同步完成");
              done();
            } catch (error) {
              ShowApiError('同步失败', error);
              done();
              return;
            } finally {
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "确 定";
            }
          } else {
            done();
          }
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "取消"
        });
      });
    }
  }
};
